export const sort = () => {
    return (a, b, tableState) => {
        const { order = "asc" } = tableState || {};
        const orderBy = (tableState === null || tableState === void 0 ? void 0 : tableState.orderBy) || "createdAt";
        const pick = (obj, path) => path.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), obj);
        const getValue = (obj, field) => {
            const value = pick(obj, field);
            if (value === null || value === undefined)
                return "";
            const str = String(value).trim();
            if (/^\d+$/.test(str)) {
                return parseInt(str, 10).toString().padStart(6, "0");
            }
            // Check if it starts with numbers followed by letters (e.g., "123A", "12B")
            const numLetterMatch = str.match(/^(\d+)([A-Za-z]+)$/);
            if (numLetterMatch) {
                const [, numPart, letterPart] = numLetterMatch;
                const numericValue = parseInt(numPart, 10);
                return `${numericValue.toString().padStart(6, "0")}${letterPart.toLowerCase()}`;
            }
            // Check if it starts with letters followed by numbers (e.g., "A123", "B12")
            const letterNumMatch = str.match(/^([A-Za-z]+)(\d+)$/);
            if (letterNumMatch) {
                const [, letterPart, numPart] = letterNumMatch;
                const numericValue = parseInt(numPart, 10);
                return `${letterPart.toLowerCase()}${numericValue.toString().padStart(6, "0")}`;
            }
            // For mixed text with numbers at the end (like "peek Technologies 1", "New Org Test 1"),
            const mixedMatch = str.match(/^(.+?)\s*(\d+)$/);
            if (mixedMatch) {
                const [, textPart, numPart] = mixedMatch;
                const numericValue = parseInt(numPart, 10);
                const normalizedText = textPart.toLowerCase().replace(/\s+/g, " ").trim();
                return `${normalizedText}${numericValue.toString().padStart(6, "0")}`;
            }
            return str.toLowerCase();
        };
        const aVal = getValue(a, orderBy);
        const bVal = getValue(b, orderBy);
        const normalize = (v) => {
            if (v === null || v === undefined)
                return "";
            const d = new Date(v);
            if (!isNaN(d.getTime()))
                return d.getTime();
            if (typeof v === "number")
                return v;
            return String(v).toLowerCase();
        };
        const av = normalize(aVal);
        const bv = normalize(bVal);
        let cmp;
        if (typeof av === "number" && typeof bv === "number") {
            cmp = av - bv;
        }
        else {
            cmp = String(av).localeCompare(String(bv));
        }
        return order === "desc" ? -cmp : cmp;
    };
};
